// Validation logic was requested by the buhl team
// See https://deltra.atlassian.net/browse/BA-3286?focusedCommentId=38007
export default function validateName(value: string): boolean {
  let firstChar = ''
  let valid = false
  const chars = /^[\p{Letter}\p{Mark}\s-]+$/u

  for (let i = 0; i < value.length; i++) {
    if (i === 0) {
      firstChar = value.charAt(i)
    }
    if (firstChar !== value.charAt(i)) {
      valid = true
    }
  }

  if (chars.test(value) && value.trimStart().length > 1 && valid === true && value.charAt(0) !== '-') {
    return true
  } else {
    return false
  }
}
